import React from 'react';
import { Badge } from 'react-bootstrap';
import IntlMessages from 'helpers/IntlMessages';
import { EventCourse } from 'services/graphqltypes';

interface ActivityLabelProps {
    event: EventCourse;
}

/* labels an activity as a Route or a Course */
const ActivityLabel = ({ event }: ActivityLabelProps): React.ReactElement =>{
  return (
    <>
      {/* display badge for only courses and events with specimens */}
      {((event.type === 'COURSE') || (event.type === 'ROUTE')) && (
        <Badge color="primary" pill className="badge-primary position-absolute badge-top-left">
          { event.type === 'COURSE'  ?
            <IntlMessages id="course.course" />  : /* display  course */
            <IntlMessages id="general.route" /> /* display Route */
          }
        </Badge>
      )}
    </>
  );
};

export default ActivityLabel;
